export class ProductCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelectorAll('.color-swatch').forEach((s) => s.addEventListener('click', this.onSwatchClick.bind(this)));
  }

  onSwatchClick(event) {
    const swatch = event.target;
    const productImage = this.querySelector(`[data-product-image="${this.dataset.productId}"]`);
    const swatchImageElement = swatch.querySelector('.data-variant-image');
    let newImageUrl = swatchImageElement ? swatchImageElement.getAttribute('src') : null;
    let newSrcset = swatchImageElement ? swatchImageElement.getAttribute('srcset') : null;
    if (newImageUrl === null) {
      newImageUrl = swatch ? swatch.getAttribute('src') : null;
      newSrcset = swatch ? swatch.getAttribute('srcset') : null;
    }
    this.querySelectorAll('.color-swatch').forEach((s) => s.classList.remove('selected'));
    swatch.classList.add('selected');

    if (productImage && newImageUrl) {
      productImage.src = newImageUrl;
      productImage.srcset = newSrcset;
    }
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard);
}

/**
 * Servings info — the (i) after a card's servings, opening the breakdown kept in
 * `custom.product_serving_popup`. Hover with a pointer, tap without one, and it
 * shuts on scroll on touch screens, as live's does (assets/custom-script.js).
 */
if (!customElements.get('servings-info')) {
  customElements.define(
    'servings-info',
    class ServingsInfo extends HTMLElement {
      get button() {
        return this.querySelector('.servings-info__button');
      }

      get panel() {
        return this.querySelector('.servings-info__panel');
      }

      get isPointer() {
        return window.matchMedia('(hover: hover)').matches;
      }

      connectedCallback() {
        this.addEventListener('mouseenter', this.onEnter);
        this.addEventListener('mouseleave', this.onLeave);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('focusout', this.onFocusOut);
        this.button?.addEventListener('click', this.onClick);
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('scroll', this.onScroll, { capture: true, passive: true });
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('scroll', this.onScroll, { capture: true });
      }

      onEnter = () => {
        if (this.isPointer) this.toggle(true);
      };

      onLeave = () => {
        if (this.isPointer) this.toggle(false);
      };

      // With a pointer, hover has already opened it, so a click only confirms.
      onClick = () => {
        this.toggle(this.isPointer || this.panel.hidden);
      };

      onKeydown = (event) => {
        if (event.key !== 'Escape' || this.panel.hidden) return;
        this.toggle(false);
        this.button?.focus();
      };

      onFocusOut = (event) => {
        if (!this.contains(event.relatedTarget)) this.toggle(false);
      };

      onDocumentClick = (event) => {
        if (!this.contains(event.target)) this.toggle(false);
      };

      onScroll = () => {
        if (!this.isPointer) this.toggle(false);
      };

      toggle(open) {
        if (!this.panel || this.panel.hidden === !open) return;
        this.panel.hidden = !open;
        this.button?.setAttribute('aria-expanded', String(open));
      }
    },
  );
}
